import { motion } from "framer-motion";
import { WhatsAppIcon } from "./BrandIcons";
import { waLink } from "@/lib/site";

export const WhatsAppFloat = () => (
  <motion.a
    data-testid="floating-whatsapp-btn"
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Fale conosco pelo WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 18 }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="group fixed bottom-5 right-5 z-[55] sm:bottom-7 sm:right-7"
  >
    <span className="pulse-ring absolute inset-0 rounded-full bg-[#25D366]" />
    <span className="relative grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_12px_36px_-6px_rgba(37,211,102,.7)] sm:h-16 sm:w-16">
      <WhatsAppIcon size={30} />
    </span>
    <span className="pointer-events-none absolute right-[calc(100%+12px)] top-1/2 hidden -translate-y-1/2 translate-x-2 whitespace-nowrap rounded-full bg-white px-4 py-2 text-sm font-semibold text-ws-bg opacity-0 shadow-xl transition-[opacity,transform] duration-300 group-hover:translate-x-0 group-hover:opacity-100 sm:block">
      Fale conosco pelo WhatsApp
    </span>
  </motion.a>
);
